import roMessages from '../locales/ro_RO.json';

const RoLang = {
  messages: {
    ...roMessages,
  },
  locale: 'ro-RO',
};
export default RoLang;
